export default "__VITE_ASSET__DdLjwCyY__"